import React, { createContext, useContext, ReactNode } from "react";

// Define the shape of the context
const DEFAULT_CONTEXT = {
  videoId: '',
  video: {}
}

// Create the context with undefined as default value
const StoryboardContext = createContext(undefined);

// Provider component that wraps parts of the app that need access to the context
export const StoryboardProvider = ({ value, children }) => {
  return (
    <StoryboardContext.Provider value={value ?? DEFAULT_CONTEXT}>{children}</StoryboardContext.Provider>
  );
};

// Custom hook that components can use to access the context
// Throws an error if used outside of EditorProvider
export const useStoryboardContext = () => {
  const context = useContext(StoryboardContext);
  if (!context) {
    throw new Error("useStoryboardContext must be used within an StoryboardProvider");
  }
  return context;
};
